<template>
  <div
    class="calendar-container"
    :style="cssColors"
  >
    <client-only>
      <div
        v-click-outside="handleClickOutside"
        class="date-picker-container"
      >
        <DatePicker
          v-model="vModelDate"
          :locale="{ masks: { weekdays: 'WW' } }"
          expanded
          :popover="{ visibility: 'hidden' }"
          mode="date"
          :attributes="attributes"
          :update-on-input="false"
          :max-date="maxDate"
          :min-date="minDate"
        >
          <template #default="{ inputValue, togglePopover, inputEvents }">
            <div
              class="calendar"
              :class="calendarClasses"
              @click="changeFocused"
            >
              <input
                class="calendar__input"
                placeholder="ДД.ММ.ГГГГ"
                type="text"
                :value="inputValue"
                :readonly="isMobile"
                v-on="inputEvents"
                @click="isMobile ? togglePopover() : ''"
                @input="changeValue"
              />
              <svg
                class="calendar__image"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                @click="togglePopover()"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7 1C7.55228 1 8 1.44772 8 2V3H16V2C16 1.44772 16.4477 1 17 1C17.5523 1 18 1.44772 18 2V3H21C21.5523 3 22 3.44772 22 4V9V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V9V4C2 3.44772 2.44772 3 3 3H6V2C6 1.44772 6.44772 1 7 1ZM16 5V6C16 6.55228 16.4477 7 17 7C17.5523 7 18 6.55228 18 6V5H20V8H4V5H6V6C6 6.55228 6.44772 7 7 7C7.55228 7 8 6.55228 8 6V5H16ZM4 10H20V20H4V10ZM7 12C6.80222 12 6.60888 12.0586 6.44443 12.1685C6.27998 12.2784 6.15181 12.4346 6.07612 12.6173C6.00043 12.8 5.98063 13.0011 6.01922 13.1951C6.0578 13.3891 6.15304 13.5673 6.29289 13.7071C6.43275 13.847 6.61093 13.9422 6.80491 13.9808C6.99889 14.0194 7.19996 13.9996 7.38268 13.9239C7.56541 13.8482 7.72159 13.72 7.83147 13.5556C7.94135 13.3911 8 13.1978 8 13C8 12.7348 7.89464 12.4804 7.70711 12.2929C7.51957 12.1054 7.26522 12 7 12ZM6.44443 16.4185C6.60888 16.3086 6.80222 16.25 7 16.25C7.26522 16.25 7.51957 16.3554 7.70711 16.5429C7.89464 16.7304 8 16.9848 8 17.25C8 17.4478 7.94135 17.6411 7.83147 17.8056C7.72159 17.97 7.56541 18.0982 7.38268 18.1739C7.19996 18.2496 6.99889 18.2694 6.80491 18.2308C6.61093 18.1922 6.43275 18.097 6.29289 17.9571C6.15304 17.8173 6.0578 17.6391 6.01922 17.4451C5.98063 17.2511 6.00043 17.05 6.07612 16.8673C6.15181 16.6846 6.27998 16.5284 6.44443 16.4185ZM12 12C11.8022 12 11.6089 12.0586 11.4444 12.1685C11.28 12.2784 11.1518 12.4346 11.0761 12.6173C11.0004 12.8 10.9806 13.0011 11.0192 13.1951C11.0578 13.3891 11.153 13.5673 11.2929 13.7071C11.4327 13.847 11.6109 13.9422 11.8049 13.9808C11.9989 14.0194 12.2 13.9996 12.3827 13.9239C12.5654 13.8482 12.7216 13.72 12.8315 13.5556C12.9414 13.3911 13 13.1978 13 13C13 12.7348 12.8946 12.4804 12.7071 12.2929C12.5196 12.1054 12.2652 12 12 12ZM11.4444 16.4185C11.6089 16.3086 11.8022 16.25 12 16.25C12.2652 16.25 12.5196 16.3554 12.7071 16.5429C12.8946 16.7304 13 16.9848 13 17.25C13 17.4478 12.9414 17.6411 12.8315 17.8056C12.7216 17.97 12.5654 18.0982 12.3827 18.1739C12.2 18.2496 11.9989 18.2694 11.8049 18.2308C11.6109 18.1922 11.4327 18.097 11.2929 17.9571C11.153 17.8173 11.0578 17.6391 11.0192 17.4451C10.9806 17.2511 11.0004 17.05 11.0761 16.8673C11.1518 16.6846 11.28 16.5284 11.4444 16.4185ZM17 12C16.8022 12 16.6089 12.0586 16.4444 12.1685C16.28 12.2784 16.1518 12.4346 16.0761 12.6173C16.0004 12.8 15.9806 13.0011 16.0192 13.1951C16.0578 13.3891 16.153 13.5673 16.2929 13.7071C16.4327 13.847 16.6109 13.9422 16.8049 13.9808C16.9989 14.0194 17.2 13.9996 17.3827 13.9239C17.5654 13.8482 17.7216 13.72 17.8315 13.5556C17.9414 13.3911 18 13.1978 18 13C18 12.7348 17.8946 12.4804 17.7071 12.2929C17.5196 12.1054 17.2652 12 17 12ZM16.4444 16.4185C16.6089 16.3086 16.8022 16.25 17 16.25C17.2652 16.25 17.5196 16.3554 17.7071 16.5429C17.8946 16.7304 18 16.9848 18 17.25C18 17.4478 17.9414 17.6411 17.8315 17.8056C17.7216 17.97 17.5654 18.0982 17.3827 18.1739C17.2 18.2496 16.9989 18.2694 16.8049 18.2308C16.6109 18.1922 16.4327 18.097 16.2929 17.9571C16.153 17.8173 16.0578 17.6391 16.0192 17.4451C15.9806 17.2511 16.0004 17.05 16.0761 16.8673C16.1518 16.6846 16.28 16.5284 16.4444 16.4185Z"
                  fill="#969698"
                />
              </svg>
            </div>
          </template>
        </DatePicker>
      </div>
    </client-only>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import { vOnClickOutside } from '@vueuse/components';
  import { isMobile, isTablet } from '~/utils';
  import { DatePicker } from 'v-calendar';
  import 'v-calendar/style.css';

  export default defineNuxtComponent({
    name: 'BaseCalendar',

    directives: {
      clickOutside: vOnClickOutside,
    },

    components: {
      DatePicker,
    },

    props: {
      date: {
        type: Date as PropType<Date | null>,
        required: false,
        // * чтобы календарь был изначально без значения.
        default: null,
      },
      attributes: {
        type: Array,
        default: [
          {
            key: 'today',
            highlight: false,
            dates: new Date(),
          },
        ],
      },
      primaryColor: {
        type: String,
        default: '#2962F9',
      },
      hoverColor: {
        type: String,
        default: '#264EB1',
      },
      hoverColorPopover: {
        type: String,
        default: 'rgba(41, 98, 249, 0.1)',
      },
      maxDate: {
        type: Date as PropType<Date>,
        default() {
          return new Date(2099, 0, 1);
        },
      },
      minDate: {
        type: Date as PropType<Date>,
        default() {
          return new Date(1, 0, 1);
        },
      },
    },

    data() {
      return {
        AsyncComponent: null,
        focused: false,
        isMobile: false,
        vModelDate: null,
      };
    },

    computed: {
      cssColors(): string {
        return `
      --color-primary: ${this.primaryColor};
      --color-hover: ${this.hoverColor};
      --color-hover-popover: ${this.hoverColorPopover}
      `;
      },
      calendarClasses(): Record<string, boolean> {
        const isError = Boolean(this.date && this.date < this.minDate);
        return {
          'calendar--focused': isError ? false : this.focused,
          'calendar--error': isError,
        };
      },
    },

    watch: {
      vModelDate(newVal) {
        this.$emit('updateDate', newVal ? new Date(newVal) : null);
      },
    },

    mounted() {
      this.testDate = this.date;

      if (isMobile() || isTablet()) {
        this.isMobile = true;
      }
    },

    methods: {
      changeFocused() {
        this.focused = !this.focused;
      },
      handleClickOutside() {
        this.focused = false;
      },
      changeValue($event: any) {
        if ($event.inputType === 'deleteContentBackward' && $event.target.value.length > 0) {
          const selectionStart = $event.target.selectionStart;
          const addZeroInValue = $event.target.value.split('');
          addZeroInValue.splice(selectionStart, 0, 0);
          $event.target.value = addZeroInValue.join('');
          this.$nextTick(() => {
            $event.target.focus();
            $event.target.setSelectionRange(+selectionStart, +selectionStart + 1);
          });
        }

        const x = $event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
        $event.target.value = !x[2] ? x[1] : x[1] + '.' + x[2] + (x[3] ? '.' + x[3] : '');
      },
    },
  });
</script>

<style lang="scss" scoped>
  $color-dark: #000;
  .calendar-container {
    &:focus {
      border: 1px solid var(--color-primary);
    }
  }
  .calendar-container {
    background: #fff;
    width: 100%;
    height: 48px;
    &:focus {
      border: 1px solid var(--color-primary);
    }
    :deep(input[type='text']) {
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      font-family: $mainFont;
    }
    :deep(.vc-container) {
      * {
        font-family: $mainFont;
        &:focus {
          border: 0 !important;
        }
      }
    }
    :deep(.vc-pane) {
      width: 290px;
      @include tablet {
        width: 306px;
      }
    }
    :deep(.vc-title) {
      color: var(--color-primary);
      background: none;
      @include hover {
        color: var(--color-hover);
        opacity: 1;
      }
    }
    :deep(.vc-day-content) {
      @include hover {
        background: var(--color-hover-popover);
      }
      &:focus {
        background: var(--color-hover-popover);
      }
    }
    :deep(.vc-highlight) {
      background-color: var(--color-primary) !important;
    }
    :deep(.vc-header) {
      padding: 16px 24px 0;
      @include tablet {
        padding: 24px 24px 0;
      }
    }
    :deep(.vc-weeks) {
      padding: 20px 16px;
      margin-top: 20px;
      @include tablet {
        margin-top: 20px;
        padding: 20px 24px;
      }
      .vc-week {
        gap: 8px;
      }
      .vc-weekday {
        text-transform: capitalize;
        color: #a0aec0;
        margin-bottom: 8px;
      }
      .vc-day {
        height: 35px;
      }
    }
    :deep(.vc-day-content) {
      padding: 8px;
      font-weight: 600;
      font-size: 14px;
    }
    :deep(.vc-nav-item),
    :deep(.vc-nav-title) {
      font-weight: 400;
      line-height: 24px;
      color: $color-dark;
    }
    :deep(.vc-nav-title) {
      border: 0;
      &:hover {
        background: transparent;
      }
    }
    :deep(.vc-nav-popover-container) {
      background-color: #f2f0f0;
      padding: 16px;
    }
    :deep(.vc-popover-caret) {
      display: none;
    }
    :deep() {
      .vc-popover-content .direction-bottom {
        border: 1px solid #4a5568;
      }
    }
    :deep(.vc-popover-content) {
      .direction-bottom {
        margin-top: 8px;
      }
    }
    :deep(.vc-arrow) {
      max-width: 20px;
      background: none;
      svg {
        stroke: #969698;
      }
      &:hover {
        border: 0;
        background: transparent;
        svg {
          stroke: $color-dark;
        }
      }
    }
    :deep(.vc-nav-arrow) {
      max-width: 20px;
      background: none;
      svg {
        stroke: #969698;
      }
      &:hover {
        border: 0;
        background: transparent;
        svg {
          stroke: $color-dark;
        }
      }
    }
    :deep(.vc-nav-item).is-active {
      color: #fff;
      background: var(--color-primary);
      &:hover {
        background: transparent;
        @include big-tablet {
          background: var(--color-primary);
        }
      }

      &:focus {
        border: 0;
      }
    }
    :deep(.vc-nav-item) {
      border: 0;
      &:hover {
        background: transparent;
        @include big-tablet {
          background: #fff;
        }
      }
    }
    :deep(.vc-arrow) {
      &:hover {
        background: transparent;
        path {
          fill: $color-dark;
        }
      }
    }
  }

  .calendar {
    background: #fff;
    padding-right: 16px;
    border: 1px solid #e7e7e7;
    height: 48px;
    width: 100%;
    display: flex;
    align-items: center;
    @include hover {
      border: 1px solid var(--color-primary);
      svg {
        pointer-events: all;
        cursor: pointer;
        path {
          fill: var(--color-primary);
        }
      }
    }

    &--focused {
      border: 1px solid var(--color-primary);
      svg {
        path {
          fill: var(--color-primary);
        }
      }
    }
    &--error {
      border: 1px solid #fd4b4b;
      .calendar__input {
        color: #fd4b4b;
      }
      @include hover {
        border: 1px solid #fd4b4b;
        svg {
          path {
            fill: #969698;
          }
        }
      }
    }
    [data-focus-visible] {
      outline: none;
    }
    &__input {
      padding-left: 16px;
      border: none;
      height: 100%;
      width: 100%;
      &:hover {
        outline: none;
      }
      &:focus {
        outline: none;
      }
      &:focus-visible {
        outline: none;
      }
    }
    &--active {
      border: 1px solid var(--color-primary);
    }
  }
</style>
